<template>
  <div data-test-id="DailyCasesByPriorityChartContainerComponent" class="casechart">
    <DailyCasesByPriorityChart
      v-if="loaded && count > 0"
      :labels="labels"
      :chart-data="chartData"
      :data1="data1"
      :data2="data2"
      :data3="data3"
      :is-admin="isAdmin"
      :styles="{ height: '250px', position: 'relative' }"
      :timespan="timespan"
    />
    <Spinner v-if="loading" />
  </div>
</template>

<script>
import DailyCasesByPriorityChart from "@/Dashboard/components/DailyCasesByPriorityChart";
import Spinner from "@/App/components/Spinner";

export default {
  name: "DailyCasesByPriorityChartContainer",
  components: { DailyCasesByPriorityChart, Spinner },
  props: {
    chartData: {
      type: Array,
      default: () => []
    },
    data1: {
      type: Array,
      default: () => []
    },
    data2: {
      type: Array,
      default: () => []
    },
    data3: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => []
    },
    loaded: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    timespan: {
      type: String,
      default: "month"
    }
  }
};
</script>

<style scoped lang="css">
.casechart {
  max-width: 1000px;
  max-height: 300px;
  margin: auto;
  margin-top: 15px;
}
</style>
